module.exports = __webpack_public_path__ + "static/message.bcb11678.png";